/**
 * A threat report row always carries an English ``threat_report_json``.
 * When the report was requested in another language, the native body is
 * returned alongside it as ``threat_report_json_native``.
 */
export type ThreatReportBodyRow = {
  threat_report_json?: unknown;
  threat_report_json_native?: unknown;
};

function stringBody(value: unknown): string {
  return typeof value === "string" ? value.trim() : "";
}

/** JSON string the viewer should render: native when present, otherwise English. */
export function threatReportBodyJson(row: ThreatReportBodyRow | null | undefined): string {
  const native = stringBody(row?.threat_report_json_native);
  if (native && native !== "{}") return native;
  return stringBody(row?.threat_report_json);
}

/** Parsed report body, falling back to the English copy if the native JSON is invalid. */
export function parseThreatReportBody(
  row: ThreatReportBodyRow | null | undefined,
): Record<string, unknown> | null {
  const native = stringBody(row?.threat_report_json_native);
  const english = stringBody(row?.threat_report_json);
  const preferred = native && native !== "{}" ? native : english;
  if (!preferred) return null;
  try {
    const parsed = JSON.parse(preferred);
    return parsed && typeof parsed === "object" ? (parsed as Record<string, unknown>) : null;
  } catch {
    if (!english || english === preferred) return null;
    try {
      const parsed = JSON.parse(english);
      return parsed && typeof parsed === "object" ? (parsed as Record<string, unknown>) : null;
    } catch {
      return null;
    }
  }
}
